import HBConfigManager from './header-bidding/config-manager';
import app             from './application';
import {
  isEmpty,
  getParameterByName,
  load,
  extend
} from './utils';
import {
  showLog,
  showWarn,
  showError
} from './logger';
import {
  DEFAULTS,
  SLOT_INACTIVE,
  OLD_PREFIX,
  NEW_SUFFIX,
  ALTOS_MINIMOS_DISPOSITIVOS,
  GPT_ID_VOCENTO,
  EDITIONS_NAMESPACE,
  CAPTURADOR_WS,
  VAM_CSS_URL,
  MCRYPT_KEY
} from './constants';

const URL_PARAM_ALL = 'all';

var
  _dynamicId           = -1,
  _prevEncryptedCode   = '',
  _prevUnencryptedCode = ''
;

class ConfigManager {
  constructor(configGDPMedio, configGDP) {
    _prevEncryptedCode         = '';
    _prevUnencryptedCode       = '';
    this.configGDPMedio        = extend({}, configGDPMedio);
    this.configGDP             = extend({}, configGDP);
    this.deviceType            = _getTipoDispositivo.call(this);
    this.pageType              = _getTipoPagina.call(this);
    this.dynamicId             = ++_dynamicId;
    this.context$              = null;
    this.isResponsiveMedia     = _isResponsiveMedia.call(this);
    this.capturadorDataPreview = '';
    this.valueUserType         = _getValueUser();
    this.delayedPositions      = _getDelayed.call(this);
    this.prioritizedPositions  = _getPrioritized.call(this);
    this.globalTargetings      = _getDefineSlotTargetings.call(this);
  }

  /**
   * Process the configGDPMedia
   */
  processConfig() {
    HBConfigManager.processConfig(this);
  }

  /**
   * Check if a position is enabled or disabled
   * @param  {object} params
   * @return {boolean}
   */
  isActive(params) {// OK
    var container$, configPosition, configSchedules, currentDate, found;

    // check if all positions or the given in params are actives by URL
    if ('forceActivePosition' in this.configGDPMedio &&
        (this.configGDPMedio.forceActivePosition.indexOf('1')            > -1 ||
        this.configGDPMedio.forceActivePosition.indexOf(URL_PARAM_ALL)   > -1 ||
        this.configGDPMedio.forceActivePosition.indexOf(params.position) > -1)
    ) {
      return true;
    }

    container$     = $(`#${this.getIdDiv(params)}`);
    configPosition = app.lookup(`posicion_${this.deviceType}.${params.position}`, this.configGDP);

    // Checking that the config of the device type is added

    if (!isEmpty(configPosition)) {
      // Check if the position is active for the page type
      if (configPosition.desactivadoen && configPosition.desactivadoen.length
        && configPosition.desactivadoen !== ''
        && configPosition.desactivadoen.indexOf(this.pageType) !== -1
      ) {
        showLog(`ConfigManager:isActive:Position ${params.position} is not active for the pageType ${this.pageType}`);
        container$.trigger(SLOT_INACTIVE);
        return false;
      }

      // Check if the position has programming
      currentDate     = Math.round(+new Date() / 1000);
      found           = false;
      configSchedules = app.lookup(`posicion_${this.deviceType}.${params.position}.programaciones`, this.configGDP);
      if (!isEmpty(configSchedules) && configSchedules.length) {
        found = configSchedules.some(function(current) {
          var beginDate, endDate;
          beginDate = current.programacion ? current.programacion.fecha_in  : 0;
          endDate   = current.programacion ? current.programacion.fecha_fin : 0;
          return (beginDate === 0 || currentDate >= beginDate)
              && (endDate   === 0 || currentDate <= endDate);
        });

        if (!found) {
          showLog(`ConfigManager:isActive:Position ${params.position} is not active for the current date`);
          container$.trigger(SLOT_INACTIVE);
          return false;
        }
      }
    } else {
      showLog(`ConfigManager:isActive:Position ${params.position} is not active`);
      container$.trigger(SLOT_INACTIVE);
      return false;
    }

    return true;
  }

  /**
   * Generate position identifier
   * FUTURE: Clean this method when all pages(ABC, MH, PPLL) use the
   *         new ADS strategy(PREFIX or SUFIX come from GDP)
   * @param  {object} params
   * @return {string}
   */
  getIdDiv(params) {// OK
    var adsId, dynamicId;

    showLog('ConfigManager:getIdDiv:Dinamic ID', params.dynamicId, this.dynamicId);
    dynamicId = this.dynamicId ? `-${this.dynamicId}` : '';
    if (params.dynamicId !== undefined) {
      dynamicId = params.dynamicId ? `-${params.dynamicId}` : '';
    }
    if (params.id && typeof params.id === 'string') {
      showLog('ConfigManager:getIdDiv:With Id param', params);
      adsId = params.id.indexOf(OLD_PREFIX) > -1 ? params.id : `${OLD_PREFIX}${params.id}`;
      if (!$(`#${adsId}`).length) {
        showLog('ConfigManager:getIdDiv:With Id param. Not found ID', adsId);
        adsId = params.id.indexOf(NEW_SUFFIX) > -1 ? params.id : `${params.id}${NEW_SUFFIX}`;
      }
      adsId += adsId.endsWith(dynamicId) ? '' : dynamicId;
      showLog('ConfigManager:getIdDiv:With Id param. Id calculated', adsId);
    } else {
      showLog('ConfigManager:getIdDiv:No Id param', params);
      adsId = `${OLD_PREFIX}${params.position}`;
      if (!$(`#${adsId}`).length) {
        showLog('ConfigManager:getIdDiv:No Id param. Not found ID', adsId);
        adsId = `${params.position}${NEW_SUFFIX}${dynamicId}`;
      }
      showLog('ConfigManager:getIdDiv:No Id param. Id calculated', adsId);
    }

    return adsId;
  }

  /**
   * Check if position exist in media config
   * @param   {string} position
   * @param   {string} deviceType
   * @returns {boolean} - TRUE if exist, FALSE otherwise
   */
  existePosEnConfigGDPMedio(position, deviceType = this.deviceType) {// OK
    var idAds;

    if (!isEmpty(app.lookup(`posicion_${deviceType}.${position}`, this.configGDPMedio))) {
      return true;
    }
    // If position do not exist, hide the container DIV
    idAds = this.getIdDiv({position});
    $(`#${idAds}`).length && $(`#${idAds}`).hide();

    return false;
  }

  /**
   * Normalize the position's parameters
   */
  normalizaParams(data) {// OK
    var params, outOfPage, idAds, offset;

    params = {};
    // jQuery object or JSON object
    if (data instanceof $) {
      extend(params, DEFAULTS, {
        position:      data.data('voc-vam-position')     || null,
        serverType:    data.data('voc-vam-servertype')   || _getServerType.call(this, params.position),
        hideNoAds:     data.data('voc-vam-hidenoads'),
        outOfPage:     data.data('voc-vam-outofpage'),
        defineSlot:    data.data('voc-vam-defineslot')   || _getDefineSlotParam.call(this),
        refresh:       data.data('voc-vam-refresh'),
        responsive:    data.data('voc-vam-responsive'),
        pre_callback:  data.data('voc-vam-precallback')  || '',
        pre_event:     data.data('voc-vam-preevent')     || '',
        post_callback: data.data('voc-vam-postcallback') || '',
        post_event:    data.data('voc-vam-postevent')    || '',
        oas:           data.data('voc-vam-oas')          || '',
        tags:          data.data('voc-vam-tags'),
        dynamicId:     this.dynamicId
      });
    } else {
      extend(params, DEFAULTS, {
        position:      data.position      || null,
        id:            data.id            || null,
        serverType:    data.serverType    || _getServerType.call(this, params.position),
        hideNoAds:     data.hideNoAds,
        outOfPage:     data.outOfPage,
        defineSlot:    data.defineSlot    || _getDefineSlotParam.call(this),
        refresh:       data.refresh,
        responsive:    data.responsive,
        pre_callback:  data.pre_callback  || '',
        pre_event:     data.pre_event     || '',
        post_callback: data.post_callback || '',
        post_event:    data.post_event    || '',
        oas:           data.oas           || '',
        tags:          data.tags,
        dynamicId:     data.dynamicId     || this.dynamicId
      });
    }

    // if some required parameter is missing, return null
    if (params.position === null) {
      showWarn('ConfigManager:normalizaParams:Position param is required', data);
      return null;
    }

    if (!this.existePosEnConfigGDPMedio(params.position)) {
      showWarn(`ConfigManager:normalizaParams:Position ${params.position} does not exists in configGDPMedio`);
      return null;
    }

    // OutOfPage param
    if (typeof params.outOfPage !== 'boolean') {
      outOfPage = app.lookup(`posicion_${this.deviceType}.${params.position}.outofpage`, this.configGDPMedio);
      params.outOfPage = isEmpty(outOfPage) || typeof outOfPage !== 'boolean' ? false : outOfPage;
    }

    // ads container DIV
    idAds = this.getIdDiv(params);
    if (!$(`#${idAds}`).length && $(`[data-voc-vam-position = '${params.position}']`, this.context$).length && !$(`[data-voc-vam-position = '${params.position}']`, this.context$).attr('id')) {
      $(`[data-voc-vam-position = '${params.position}']`, this.context$).attr('id', idAds);
    }
    params.id = idAds;

    // global targetings
    if (!params.tags) {
      params.tags = app.lookup(`posicion_${this.deviceType}.${params.position}.targetings`, this.configGDPMedio) || {};
    }

    // offset
    offset = app.lookup(`posicion_${this.deviceType}.${params.position}.offset`, this.configGDP);
    if (!isEmpty(offset)) {
      $(`#${params.id}`).attr('data-offset', offset);
      showLog(`ConfigManager:normalizaParams:Offset ${offset} configurer for position: ${params.position}`);
    }

    // build the responsive parameter if it doesn't come in the data
    if (!params.outOfPage
        && !params.responsive
        && this.isResponsiveMedia) {
      params.responsive = _getResponsiveParam.call(this, params);
    }

    return params;
  }

  /**
   * Get OAS value from config
   * FUTURE: create final OAS config on GDP
   * @return string
   */
  getOasSitepage(params = {}) {
    var oasSitepage, decryptedURL, legacyAdUnit, regExp, result, macroEdition, edition;

    if (params.oas) {
      oasSitepage = params.oas.trim();
    } else {
      oasSitepage = app.lookup(`OAS.${this.deviceType}.${this.pageType}`, this.configGDP);
      oasSitepage = isEmpty(oasSitepage) ? '' : oasSitepage.trim();
    }

    // check if adUnit is forced by URL
    try {
      decryptedURL = ConfigManager.decryptedURL();
      if (window.location.href.indexOf('vam_adunit=') > -1 || window.location.href.indexOf('adunit=') > -1 || decryptedURL !== '') {
        legacyAdUnit = window.location.href.indexOf('vam_adunit=') > -1 ? 'vam_adunit' : 'adunit';
        regExp = new RegExp(`(\\?|&)${legacyAdUnit}=([^?&]+)`);
        result = (decryptedURL !== '') ? regExp.exec(decryptedURL) : regExp.exec(window.location.href);

        if (result) {
          oasSitepage = result[2].indexOf('/' + GPT_ID_VOCENTO + '/') > -1
            ? result[2]
            : '/' + GPT_ID_VOCENTO + '/' + result[2];
        }
      }
    } catch (err) {
      showError('ConfigManager:getOasSitepage:Error checking adUnit', err);
    }

    // check macro edition
    try {
      regExp = /{(\/)?edicion(\/)?}/;
      macroEdition = regExp.exec(oasSitepage);
      if (macroEdition) {
        edition = _getEdition();
        if (macroEdition[0].startsWith('{/') && edition) edition  = '/' + edition;
        if (macroEdition[0].endsWith('/}')   && edition) edition += '/';

        oasSitepage = oasSitepage.replace(macroEdition[0], edition);
      }
    } catch (err) {
      showError('ConfigManager:getOasSitepage:Error checking edition', err);
    }

    // Guardamos el valor del adunit calculado por si no lo esta
    if (typeof this.configGDP.OAS.adunit === 'undefined') this.configGDP.OAS.adunit = oasSitepage;

    return oasSitepage;
  }

  /**
   * Calculate the sizes for a given position
   * FUTURE: move config to GDP
   * @param  {string} position
   * @param  {string} deviceType - default is _deviceType
   * @return {object}
   */
  getSizesGoogle(position, deviceType = this.deviceType) {// OK
    var configSize, size, defineSlot;

    configSize = app.lookup(`posicion_${deviceType}.${position}.dimensiones`, this.configGDPMedio);

    size       = !isEmpty(configSize) ? configSize : '[]';
    defineSlot = _getDefineSlotParam.call(this);

    if (size.indexOf('[fluid]') > -1) {
      if (!defineSlot) return ['fluid'];

      size = size.replace('[fluid]', '\'fluid\'');
    }

    return defineSlot ? size : JSON.parse(size);
  }

  /**
   * Detect forced config by URL.
   * Support params:
   *   vam_adunit
   *   vam_cmvkey
   *   vam_debug
   *   vam_enable_single_request
   *   vam_enable_sync_rendering
   *   vam_enable_krux
   *   vam_force_positions
   *   vam_info_slot
   */
  checkConfigFromURL() {
    var legacyCode, code, prebidDisabledBidders;
    if (typeof window.location === 'undefined') return;

    // Disable Prebid
    if ('headerBidding' in this.configGDPMedio &&
        window.location.href.indexOf('vam_prebid_disabled=') > -1
    ) {
      prebidDisabledBidders = getParameterByName('vam_prebid_disabled', window.location.href).split(',');
      this.configGDPMedio.headerBidding.biddersConfig.disabled = prebidDisabledBidders;
      if (prebidDisabledBidders.indexOf(URL_PARAM_ALL) > -1) {
        this.configGDPMedio.headerBidding = null;
      }
    }

    // Disable HB Amazon
    if ('hbAmazon' in this.configGDPMedio) {
      this.configGDPMedio.hbAmazon = window.location.href.indexOf('vam_amazon_disabled=1') > -1 || window.location.href.indexOf('gdp_enableAmazonAds=0') > -1 || !this.configGDPMedio.enableAmazonAds ? false : this.configGDPMedio.hbAmazon;
    }

    // Single Request
    this.configGDPMedio.singleRequest = window.location.href.indexOf('vam_single_request=1') > -1 || window.location.href.indexOf('gdp_singleRequest=1') > -1 || this.configGDPMedio.singleRequest;

    // SyncRendering
    this.configGDPMedio.syncRendering = window.location.href.indexOf('vam_sync_rendering=1') > -1 || window.location.href.indexOf('gdp_syncRendering=1') > -1 || this.configGDPMedio.syncRendering;

    // Krux
    this.configGDPMedio.enableKrux = window.location.href.indexOf('vam_krux=1') > -1 || window.location.href.indexOf('gdp_enableKrux=1') > -1 || this.configGDPMedio.enableKrux;

    // Force active position
    this.configGDPMedio.forceActivePosition = window.location.href.indexOf('vam_force_positions=') > -1 ? getParameterByName('vam_force_positions', window.location.href).split(',') : getParameterByName('gdp_forceActivePosition', window.location.href).split(',');

    // InfoSlot
    this.configGDPMedio.infoSlot = window.location.href.indexOf('vam_info_slot=1') > -1 || window.location.href.indexOf('gdp_infoSlot=1') > -1;
    if (this.configGDPMedio.infoSlot) {
      load(VAM_CSS_URL, {
        type: 'link'
      }).then(function() {
        showLog('ConfigManager:checkConfigFromURL:CSS loaded', VAM_CSS_URL);
      });
    }

    // Capturador (modo preview)
    this.configGDPMedio.preview = window.location.href.indexOf('vam_preview') > -1 || window.location.href.indexOf('preview') > -1;
    if (this.configGDPMedio.preview) {
      showLog('ConfigManager:checkConfigFromURL:Detected capture mode. Call capture SW');
      this.capturadorDataPreview = _capturadorGetPreviewData();

      // En modo capturador no pondremos priorizadas ni retrasadas
      this.configGDP.priorizadas = {};
      this.configGDP.retrasadas  = {};
    }

    // Previsualizador
    if (window.location.href.indexOf('vam_code=') > -1 || window.location.href.indexOf('code=') > -1) {
      showLog('ConfigManager:checkConfigFromURL:Detected preview mode');
      legacyCode         = window.location.href.indexOf('vam_code=') > -1 ? 'vam_code' : 'code';
      code               = getParameterByName(legacyCode, window.location.href);
      _prevEncryptedCode = decodeURI(code);

      // En modo previsualizador no pondremos priorizadas ni retrasadas
      this.configGDP.priorizadas = {};
      this.configGDP.retrasadas  = {};

      if (_prevEncryptedCode !== '') {
        import(/* webpackChunkName: "rijndael-js" */ 'rijndael-js').then(function(Rijndael) {
          showLog('ConfigManager:Rijndael library is loaded', Rijndael);
          _decriptUrl(Rijndael);
        });
      }
    }
  }

  /**
   * Comprobacion de si existen excepciones para la pagina donde nos encontramos.
   * @return object configGDP
   */
  checkExceptions() {
    var value, unixTime, beginDate, endDate;

    if (this.configGDPMedio.excepciones
        && Object.keys(this.configGDPMedio.excepciones).length > 0
    ) {
      showLog('ConfigManager:checkExceptions:There are configured exceptions');
      Object.keys(this.configGDPMedio.excepciones).forEach(function(key) {
        if (key !== 'priorizadas' && key !== 'retrasadas') {
          if (window.location.pathname === key || window.location.pathname.match(key)) {
            value = this.configGDPMedio.excepciones[key];
            unixTime  = Math.round(new Date() / 1000);
            beginDate = value.fecha_in;
            endDate   = value.fecha_fin;
            if ((beginDate === 0 || beginDate <= unixTime) &&
                (endDate   === 0 || unixTime  <= endDate)
            ) {
              this.configGDP = value;
              showLog(`ConfigManager:checkExceptions:Applying the following exception:"${key}"`);
            }
          }
        }
      }, this);
    }
  }

  /**
   * Funcion que devuelve la URL desencriptada
   * @returns {string}
   */
  static decryptedURL() {
    return _prevUnencryptedCode;
  }

  /**
   * Funcion que comprueba si una posicion es retrasada
   * FUTURE: listaRetrasadas come in array format from GDP
   */
  isDelayed(position) {
    return this.thereAreDelayedPositions() && this.delayedPositions.indexOf(position) > -1;
  }

  thereAreDelayedPositions() {
    return this.delayedPositions.length;
  }

  /**
   * Funcion que comprueba si una posicion es retrasada
   * FUTURE: listaRetrasadas come in array format from GDP
   */
  isPrioritized(position) {
    return this.thereArePrioritizedPositions() &&
           this.prioritizedPositions.indexOf(position) > -1;
  }

  thereArePrioritizedPositions() {
    return this.prioritizedPositions.length;
  }

  removePrioritizedPosition(position) {
    var index = this.prioritizedPositions.indexOf(position);

    if (index !== -1) {
      this.prioritizedPositions.splice(index, 1);
    }
  }
}

export default ConfigManager;

/* Private */

/**
 * Get the device type depending on the size of the screen
 * @return string
 */
function _getTipoDispositivo() {// OK
  var max, min, screenWidth, deviceType;

  deviceType = 'desktop';

  if (!this.configGDPMedio.responsive.esResponsive) {
    if (this.configGDPMedio && this.configGDPMedio.tipoDispositivo) {
      deviceType = this.configGDPMedio.tipoDispositivo;
    }
  } else {
    screenWidth = parseInt(window.innerWidth, 10);

    Object.keys(this.configGDPMedio.responsive).forEach(function(key) {
      var value = this.configGDPMedio.responsive[key];
      if ((key !== 'esResponsive') && (value.resolucionMaxima || value.resolucionMinima)) {
        max = value.resolucionMaxima ? value.resolucionMaxima : 999999;
        min = value.resolucionMinima ? value.resolucionMinima : 0;

        if ((screenWidth <= max) && (screenWidth > min)) {
          deviceType = key.replace('resolucion', '').toLowerCase();
        }
      }
    }, this);
  }

  return deviceType;
}

/**
 * Look for the medium where we are, from the configuration
 * @return string
 */
function _getMedio() {// OK
  return this.configGDPMedio.medio ? this.configGDPMedio.medio : '';
}

/**
 * Get the page type from the URL pattern
 * NOTE: Each medium has its own URL rules so each one has its own function to calculate them
 * FUTURE: set the page type in global namespace on each page
 */
function _getTipoPagina() {// OK
  var
    pageType = 'portada',
    medio    = _getMedio.call(this)
  ;

  if (['abc', 'lavozdigital', 'abcdesevilla'].indexOf(medio) > -1) {
    pageType = _getTipoPaginaABC();
  } else if (medio === 'mujerhoy') {
    pageType = _getTipoPaginaMujerhoy();
  } else {
    pageType = _getTipoPaginaPortalesLocales();
  }

  return pageType;
}

/**
 * Get the page type from the URL for abc.es, sevilla.abc.es and lavozdigital.es
 * @return {string}
 */
function _getTipoPaginaABC() {// OK
  var
    oldVideosRegExp, videosRegExp, oldGaleryRegExp2, oldGaleryRegExp,
    galeryRegExp, graphicRegExp, oldNewsRegExp, newsRegExp;

  oldVideosRegExp = /\/videos\/(.*)?\/\d{6}\/\d{2}\/((?!index.html).)*.html/;
  videosRegExp    = /_video.html/;
  if (videosRegExp.exec(window.location.pathname) || oldVideosRegExp.exec(window.location.pathname)) return 'video';

  oldGaleryRegExp2 = /\/multimedia\/fotos\/(.*)?\/((?!index.html).)*.html/;
  oldGaleryRegExp  = /\/fotos-(.*)?\/\d{8}\/((?!index.html).)*.html/;
  galeryRegExp     = /_galeria.html/;
  if (galeryRegExp.exec(window.location.pathname) || oldGaleryRegExp.exec(window.location.pathname) || oldGaleryRegExp2.exec(window.location.pathname)) return 'galeria';

  graphicRegExp = /\/multimedia\/(graficos\/(.)*|infografias)\/((?!index.html).)*.html/;
  if (graphicRegExp.exec(window.location.pathname)) return 'grafico';

  oldNewsRegExp = /\d{8}\/(.*)?((?!index.html).)*.html/;
  newsRegExp    = /(_noticia.html|_directo.html)/;
  if (newsRegExp.exec(window.location.pathname) || oldNewsRegExp.exec(window.location.pathname)) return 'noticia';

  return 'portada';
}

/**
 * Get the page type from the URL for mujerhoy.com
 * @return {string}
 */
function _getTipoPaginaMujerhoy() {// OK
  var
    videoRegExp, oldVideoRegExp, videoBlogRegExp, isVideo, galeryRegExp, oldGaleryRegExp,
    galeryBlogRegExp, isGalery, newsRegExp, newsBlogRegExp, newsRecipesRegExp, isNews;

  videoRegExp     = /-vi.html/;
  oldVideoRegExp  = /\/videos\/(.*)?\/\d{6}\/\d{2}\/.*-mm.html/;
  videoBlogRegExp = /\/videos\/\d{4}\/\d{2}\/\d{2}\/(.*).html/;
  isVideo         = window.location.hostname.indexOf('blogs.') > -1
    ? videoBlogRegExp.exec(window.location.pathname)
    : videoRegExp.exec(window.location.pathname) || oldVideoRegExp.exec(window.location.pathname);
  if (isVideo) return 'video';

  galeryRegExp     = /-ga.html/;
  oldGaleryRegExp  = /^\/galerias\/(.*)?\d{6}\/\d{2}\/.*-mm.html/;
  galeryBlogRegExp = /\/galerias\/\d{4}\/\d{2}\/\d{2}\/(.*).html/;
  isGalery         = window.location.hostname.indexOf('blogs.') > -1
    ? galeryBlogRegExp.exec(window.location.pathname)
    : galeryRegExp.exec(window.location.pathname) || oldGaleryRegExp.exec(window.location.pathname);
  if (isGalery) return 'galeria';

  newsRegExp        = /\/\d{6}\/\d{2}\/((?!index.html).)*.html/;
  newsBlogRegExp    = /\/\d{4}\/\d{2}\/\d{2}\/((?!index.html).)*.html/;
  newsRecipesRegExp = /\/\d{6}\/((?!index.html).)*.html/;
  if (window.location.hostname.indexOf('blogs.') > -1) {
    isNews = newsBlogRegExp.exec(window.location.pathname);
  } else if (window.location.hostname.indexOf('recetas.') > -1) {
    isNews = newsRecipesRegExp.exec(window.location.pathname);
  } else {
    isNews = newsRegExp.exec(window.location.pathname);
  }
  if (isNews) return 'noticia';

  return 'portada';
}

/**
 * Get the page type from the URL for PPLL
 * @return {string}
 */
function _getTipoPaginaPortalesLocales() {// OK
  var
    videoRegExp, oldVideoRegExp, galeryRegExp, oldGaleryRegExp, newsRegExp, oldNewsRegExp,
    graphicRegExp, oldGraphicRegExp, videoChatRegExp;

  videoRegExp    = /-(vi|virc|vivo)(_amp)?.html/;
  oldVideoRegExp = /^\/videos\/(.*)?\/\d{6}\/\d{2}\/.*-mm.html/;
  if (videoRegExp.exec(window.location.pathname) || oldVideoRegExp.exec(window.location.pathname)) return 'video';

  galeryRegExp    = /-(ga|garc|gavo|ft|ftrc|ftvo)(_amp)?.html/;
  oldGaleryRegExp = /^\/fotos\/(.*)?\d{6}\/\d{2}\/.*-mm.html/;
  if (galeryRegExp.exec(window.location.pathname) || oldGaleryRegExp.exec(window.location.pathname)) return 'galeria';

  newsRegExp    = /-(nt|ntrc|ntvo)(_amp)?.html/;
  oldNewsRegExp = /\/\d{6}\/\d{2}\/((?!index.html).)*.html/;
  if (newsRegExp.exec(window.location.pathname) || oldNewsRegExp.exec(window.location.pathname)) return 'noticia';

  // NOTA: En PLs, a nivel de publicidad, contemplaremos graficos y videochats como noticias
  graphicRegExp    = /-(in|inrc|invo)(_amp)?.html/;
  oldGraphicRegExp = /^\/graficos\/(.*)?\/\d{6}\/\d{2}\/.*-mm.html/;
  videoChatRegExp  = /\/videochats\/((?!index.html).)\w+/;
  if (graphicRegExp.exec(window.location.pathname) ||
      oldGraphicRegExp.exec(window.location.pathname) ||
      videoChatRegExp.exec(window.location.pathname)
  ) return 'noticia';

  return 'portada';
}

/**
 * Get defineSlot param from config
 * @return {boolean|undefined}
 */
function _getDefineSlotParam() {// OK
  return this.configGDPMedio.defineSlot || undefined;
}

/**
 * Get the serverType of given position
 * @param  {string} position
 * @return {string}
 */
function _getServerType(position) {// OK
  var configServerType, serverType = 'google';

  configServerType = app.lookup(
    `posicion_${this.deviceType}.${position}.tipo`,
    this.configGDPMedio
  );
  serverType = !isEmpty(configServerType) ? configServerType : serverType;

  return serverType;
}

/**
 * Check if is responsive from config
 * @return {boolean}
 */
function _isResponsiveMedia() {// OK
  var isResponsive = app.lookup('responsive.esResponsive', this.configGDPMedio);

  return !isEmpty(isResponsive) ? isResponsive : false;
}

/**
 * Build responsive param for the position
 * @return object
 */
function _getResponsiveParam(params) {// OK
  if (params.responsive
    && Array.isArray(params.responsive)
    && params.responsive.length
  ) {
    return params.responsive;
  }

  /**
   * It doesn't have responsive param but it is
   * responsive medium so we build responsive param with
   * the corresponding resolutions and sizes
   */
  if (this.isResponsiveMedia) {
    return _createResponsive.call(this, params.position);
  }

  return false;
}

/**
 * Build responsive param
 * FUTURE: move config to GDP
 * @return object
 */
function _createResponsive(position) {// OK
  var responsive, resolution, minWidth, maxWidth, dimension, googleSize, size;

  showLog('ConfigManager:createResponsive:Build responsive for', position);
  responsive = [];
  this.configGDPMedio.dispositivos.forEach(function(device) {
    if (!this.existePosEnConfigGDPMedio(position, device)) return;

    resolution = app.lookup(`responsive.resolucion${device}`, this.configGDPMedio);
    if (!isEmpty(resolution)) {
      minWidth = resolution.resolucionMinima;
      maxWidth = resolution.resolucionMaxima;

      if (!isEmpty(minWidth) && !isEmpty(maxWidth) && (minWidth || maxWidth)) {
        dimension = [
          parseInt(minWidth, 10) || 0,
          ALTOS_MINIMOS_DISPOSITIVOS[device]
        ];

        googleSize = this.getSizesGoogle(position, device);
        try {
          if (googleSize && googleSize.indexOf('fluid') > -1) {
            size = 'fluid';
          } else {
            size = JSON.parse(googleSize);
          }
        } catch (e) {
          showWarn(`ConfigManager:createResponsive:Processing position ${position}: ${e}`);
          size = googleSize;
        }

        // Insert the dimension mapping ordered from lowest to highest by width
        responsive.push([dimension, size]);
      }
    }
  }, this);
  responsive.sort(function(pair1, pair2) {
    return pair1[0][0] - pair2[0][0];
  });

  responsive.sort(function(pair1, pair2) {
    return pair1[0][0] - pair2[0][0];
  });
  showLog(`ConfigManager:createResponsive:Build responsive param for position ${position}`, responsive);

  return responsive;
}

/**
 * Get edition from config
 */
function _getEdition() {// OK
  var editions = app.lookup(EDITIONS_NAMESPACE);

  return editions.current || (editions.main || '');
}

/**
 * Invoca al Servicio Web del Capturador para obtener las creatividades indicadas en el parametro
 * preview directamente desde DFP.
 */
function _capturadorGetPreviewData() {
  var legacyPreview, url, data;

  legacyPreview = window.location.href.indexOf('vam_preview') > -1 ? 'vam_preview' : 'preview';
  url = CAPTURADOR_WS + '?id=' + getParameterByName(legacyPreview);
  data = '';
  $.ajax({
    url:     url,
    type:    'POST',
    async:   false,
    success: function (result) {
      data = result;
    }
  });

  return data;
}

/**
 * Convert Gigya user format to advertising format
 */
function _getValueUser() {// OK
  var valueUser, arrayUsers = {
    suscriptor: 's',
    trial:      't',
    registrado: 'r',
    anonimo:    'a'
  };

  valueUser = arrayUsers[app.getUserType()] || 'a';

  return valueUser;
}

function _getDelayed() {
  var delayedPositions;

  delayedPositions = app.lookup(`retrasadas.${this.deviceType}.listaPosiciones`, this.configGDP);

  if (isEmpty(delayedPositions) || !delayedPositions.length) {
    showLog('ConfigManager:getDelayed:There are NOT delayed positions');
    return [];
  }

  showLog('ConfigManager:getDelayed:There are delayed positions:', delayedPositions);
  delayedPositions = delayedPositions.split(',').filter(function(position) {
    return position.trim();
  });

  return delayedPositions;
}

function _getPrioritized() {
  var prioritizedPositions;

  prioritizedPositions = app.lookup(`priorizadas.${this.deviceType}.listaPosiciones`, this.configGDP);

  if (isEmpty(prioritizedPositions) || !prioritizedPositions.length) {
    showLog('ConfigManager:getPrioritized:There are NOT prioritized positions');
    return [];
  }

  showLog('ConfigManager:getDelayed:There are prioritized positions:', prioritizedPositions);
  prioritizedPositions = prioritizedPositions.split(',').filter(function(position) {
    return position.trim();
  });

  return prioritizedPositions;
}

/**
 * Decrypt url to get cmvkey param
 * @param {object} mcrypt - Rijndael object
 */
function _decriptUrl(Rijndael) {
  var legacyCmvkey, mcrypt, preparedCode;
  showLog('ConfigManager:decriptUrl:Actual prevUnencryptedCode', _prevUnencryptedCode, 'and prevEncryptedCode', _prevEncryptedCode);
  if (_prevUnencryptedCode === '' && _prevEncryptedCode !== '') {
    mcrypt = new Rijndael(MCRYPT_KEY, 'cbc');
    showLog('ConfigManager:decriptUrl:Decrypting', mcrypt);
    preparedCode = atob(_prevEncryptedCode).split('').map(function(value) {
      return value.charCodeAt(0);
    });
    _prevUnencryptedCode = '?' + mcrypt.decrypt(preparedCode, 256, MCRYPT_KEY);
    showLog('ConfigManager:decriptUrl:', _prevUnencryptedCode);
    // NOTE: remove special characters from string
    _prevUnencryptedCode = _prevUnencryptedCode.replace(
      /[^A-Za-z 0-9.,?""!@#$%^&*()\-_=+;:<>/\\|}{[\]`~]*/g,
      ''
    );
    if (_prevUnencryptedCode.endsWith('&vam_cmvkey=') ||
        _prevUnencryptedCode.endsWith('&cmvkey=')
    ) {
      legacyCmvkey = _prevUnencryptedCode.endsWith('&vam_cmvkey=')
        ? '&vam_cmvkey='
        : '&cmvkey=';
      _prevUnencryptedCode = _prevUnencryptedCode.replace(legacyCmvkey, '');
    }
    showLog(`ConfigManager:decriptUrl:String decrypted: ${_prevUnencryptedCode}`);
  }

  return _prevUnencryptedCode;
}

/**
 * Funcion que obtiene los tag definidos en los archivos de configuración
 * FUTURE: move config to GDP
 * @return object
 */
function _getDefineSlotTargetings() {
  var medioTargetings, pageTargetings, targetings, defineSlotTargetings;

  medioTargetings  = this.configGDPMedio.targetings ? this.configGDPMedio.targetings : {};
  pageTargetings   = this.configGDP.targetings ? this.configGDP.targetings : {};
  targetings       = {};
  extend(targetings, medioTargetings, pageTargetings);

  defineSlotTargetings = '';
  Object.keys(targetings).forEach(function(key) {
    defineSlotTargetings += `.setTargeting("${key}", "${targetings[key]}")`;
  });

  return defineSlotTargetings;
}



// WEBPACK FOOTER //
// ./src/config-manager.js